import { FormBase } from "core/components";

export default class FacilityOrderEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "facilityId",
                    label: "FACILITY_ORDER.EDIT.FACILITY_LABEL",
                    placeholder: "FACILITY_ORDER.EDIT.FACILITY_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "dateOfService",
                    label: "FACILITY_ORDER.EDIT.DATE_OF_SERVICE_LABEL",
                    placeholder: "FACILITY_ORDER.EDIT.DATE_OF_SERVICE_PLACEHOLDER",
                    rules: "required",
                },
            ],
        };
    }
}